import React, { Component } from "react";
import { SideBar, NavBar } from "../../components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
const { formatarReal } = require("../../utils");

class Atividade extends Component {
  //VERIFICADO
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.notificar = this.notificar.bind(this);
    this.handleClickVisualizar = this.handleClickVisualizar.bind(this);
    this.toggleModalDeletar = this.toggleModalDeletar.bind(this);
    this.handleClickDeletar = this.handleClickDeletar.bind(this);
    this.handleConfirmDeletar = this.handleConfirmDeletar.bind(this);

    this.state = {
      atividades: [],
      modalDeletar: false,
      idAtividadeDeletar: null,
      tema: props.getTema(),
    };
  }

  async componentDidMount() {
    this.load();
  }

  async load() {
    await axios
      .get(`${this.props.getBaseUrlApi()}/atividades`, this.props.parameters())
      .then((response) => {
        let atividades = response.data.atividades;

        for (let atividade of atividades) {
          let horas = 0;
          let minutos = atividade.tempo;

          if (atividade.tempo > 59) {
            horas = parseInt(atividade.tempo / 60);
            minutos = minutos - horas * 60;
          }
          atividade.horaFormatada = `${horas
            .toString()
            .padStart(2, "0")}:${minutos.toString().padStart(2, "0")}`;
        }

        this.setState({ atividades: atividades });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          this.notificar("warning", error.response.data.erro);
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleClickVisualizar(id) {
    this.props.history.push(`/atividades-visualizar?id=${id}`);
  }

  toggleModalDeletar() {
    this.setState({ modalDeletar: !this.state.modalDeletar });
  }

  handleClickDeletar(id) {
    this.setState({ idAtividadeDeletar: id }, () => {
      this.toggleModalDeletar();
    });
  }

  async handleConfirmDeletar() {
    let id = this.state.idAtividadeDeletar;

    await axios
      .delete(
        `${this.props.getBaseUrlApi()}/atividades/${id}`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ idAtividadeDeletar: null }, async () => {
          this.toggleModalDeletar();
          await this.load();
          this.notificar("success", "Atividade deletada com sucesso!");
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          this.notificar("warning", error.response.data.erro);
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="wrapper">
          <SideBar itemActive="atividades" />
          <div className="main-panel">
            <NavBar title="Atividades" />

            <div className="content">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div
                      className="card-header"
                      style={{ position: "relative" }}
                    >
                      <h4 className="card-title"> Lista de Atividades</h4>
                      <div className="content-btn-novo-item">
                        {" "}
                        <button
                          className="btn btn-success"
                          onClick={() => {
                            this.props.history.push("/atividades-nova");
                          }}
                        >
                          Nova Atividade
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">
                          <thead
                            className="text-primary"
                            ref={(node) => {
                              if (node) {
                                node.style.setProperty(
                                  "color",
                                  this.state.tema.textoPrincipal,
                                  "important"
                                );
                              }
                            }}
                          >
                            <th>Descrição</th>
                            <th>Tempo</th>
                            <th>Valor</th>
                            <th className="text-center">Total Atendentes</th>
                            <th className="text-center">Ações</th>
                          </thead>
                          <tbody>
                            {this.state.atividades.length > 0 &&
                              this.state.atividades.map((atividade, key) => (
                                <tr key={key}>
                                  <td>
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(atividade.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {atividade.desc}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(atividade.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {atividade.horaFormatada}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(atividade.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      R$ {formatarReal(atividade.valor)}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(atividade.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {atividade.totalAtendentes}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <div className="d-flex justifyContentCenter">
                                      <div
                                        style={{ margin: "0 3px" }}
                                        className="text-center"
                                      >
                                        <button
                                          className="btn btn-primary btn-round"
                                          onClick={() =>
                                            this.handleClickVisualizar(
                                              atividade.id
                                            )
                                          }
                                          id={`tooltip-editar-atividade-${atividade.id}`}
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>

                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`tooltip-editar-atividade-${atividade.id}`}
                                        >
                                          Editar
                                        </UncontrolledTooltip>
                                      </div>
                                      <div style={{ margin: "0 3px" }}>
                                        <button
                                          className="btn btn-danger btn-round"
                                          onClick={() =>
                                            this.handleClickDeletar(
                                              atividade.id
                                            )
                                          }
                                          id={`tooltip-deletar-atividade-${atividade.id}`}
                                        >
                                          <i className="fa fa-times"></i>
                                        </button>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`tooltip-deletar-atividade-${atividade.id}`}
                                        >
                                          Deletar
                                        </UncontrolledTooltip>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.modalDeletar}
          toggle={this.toggleModalDeletar}
        >
          <ModalHeader toggle={this.toggleModalDeletar}>
            Deletar Atividade
          </ModalHeader>
          <ModalBody>Tem certeza que deseja deletar esta atividade?</ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggleModalDeletar}
            >
              Não
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleConfirmDeletar}
            >
              Sim
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Atividade;
